/**
 * invisible is being applied by components/ui-card/card.ts and will be purged if not safelisted
 * contents is being applied by components/ui-card/card.ts and will be purged if not safelisted
 */

const safelist = ['invisible', 'contents'];
export default safelist;
